import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import './App.css';
import ChatComponent from './pages/ChatConversation';
import NotFoundPage from './pages/NotFoundPage';
import VoiceConversationRouter from './pages/VoiceConversationRouter';
import ItineraryPage from './pages/ItineraryPage';
import SparkItineraryPage from './pages/SparkItineraryPage';
import Login from './pages/Login';
import { AuthGuard } from './components/AuthGuard';

function App() {
  return (
    <RecoilRoot>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/chat"
            element={
              <AuthGuard>
                <ChatComponent />
              </AuthGuard>
            }
          />
          <Route
            path="/voice"
            element={
              <AuthGuard>
                <VoiceConversationRouter />
              </AuthGuard>
            }
          />
          <Route
            path="/itinerary"
            element={
              <AuthGuard>
                <ItineraryPage />
              </AuthGuard>
            }
          />
          <Route
            path="/spark-itinerary"
            element={
              <AuthGuard>
                <SparkItineraryPage />
              </AuthGuard>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </RecoilRoot>
  );
}

export default App;
